<template>
  <div>
    <div
      v-for="(line, index) in lines"
      :key="line.label"
      class="flex items-center justify-between border-b border-gray-800/10 pb-[15px]"
      :class="index > 0 && 'mt-[15px]'"
    >
      <div class="text-[14px] leading-[22px] text-gray-800">
        {{ line.label }}
      </div>
      <button
        v-if="line.actionLabel"
        type="button"
        class="text-link"
        @click="line.onAction?.()"
      >
        {{ line.actionLabel }}
      </button>
      <div
        v-else-if="line.value"
        class="text-[14px] leading-[22px] font-medium text-gray-800"
      >
        {{ line.value }}
      </div>
    </div>

    <div
      class="mt-[15px] flex items-center justify-between border-b border-gray-800/10 pb-[15px]"
    >
      <div class="text-[14px] leading-[22px] text-gray-500">Total</div>
      <div class="text-[14px] leading-[22px] font-medium text-gray-800">
        {{ total }}
      </div>
    </div>

    <div class="mt-[15px] flex items-start justify-between">
      <div class="text-[14px] leading-[22px] text-gray-500">Payment method</div>
      <div class="text-right">
        <div
          v-if="paymentMethod?.card"
          class="flex items-center justify-end gap-x-2.5"
        >
          <CreditCard :type="paymentMethod.card.type" />
          <div class="text-[14px] leading-[22px] font-medium text-gray-800">
            •••• •••• •••• {{ paymentMethod.card.last4 }}
          </div>
        </div>
        <button type="button" class="text-link" @click="emit('changePayment')">
          {{ paymentMethod ? 'Change' : 'Add' }}
        </button>
      </div>
    </div>

    <Alert v-if="error" variant="error" :icon="AlertIcon" class="mt-4">
      {{ error }}
    </Alert>

    <p class="mt-6 text-[12px] leading-[18px] text-gray-600">
      <slot name="terms">
        By selecting {{ action }}, you authorize Dacr to charge the amount shown
        above to your card on file. All sales are final except where required by
        law. I agree to the
        <a class="text-link" href="/legal/terms" target="_blank">Dacr Terms</a>,
        <a class="text-link" href="/legal/privacy" target="_blank"
          >Privacy Policy</a
        >, and
        <a class="text-link" href="/legal/payments" target="_blank"
          >Payments Policy</a
        >.
      </slot>
    </p>
  </div>
</template>

<script setup lang="ts">
import { Alert } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'

import CreditCard from '@/features/billing/components/CreditCard.vue'

export interface PaymentSummaryLine {
  label: string
  value?: string
  actionLabel?: string
  onAction?: () => void
}

withDefaults(
  defineProps<{
    lines: PaymentSummaryLine[]
    total: string
    paymentMethod?: { card?: { type: string; last4: string } | null } | null
    error?: string
    action?: string
  }>(),
  { paymentMethod: null, error: '', action: 'Agree and pay' }
)

const emit = defineEmits<{ changePayment: [] }>()
</script>
